import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from "../pages/outros/Login/Login";
import ForgotPassword from "../pages/outros/ForgotPassword/ForgotPassword";
import ConfirmationForgotPassword from '../pages/outros/ConfirmationForgotPassword/ConfirmationForgotPassword';
import ResetPassword from '../pages/outros/ResetPassword/ResetPassword';

const AuthRoutes = () => (
  <Switch>
     <Route exact path="/" component={Login} />
     <Route exact path="/login" component={Login} />
     <Route exact path="/forgot-password" component={ForgotPassword} />
     <Route exact path="/confirmation-forgot-password" component={ConfirmationForgotPassword} />
     <Route exact path="/reset-password/:tkn" component={ResetPassword} />
     <Redirect from="*" to="/" />
  </Switch>
);

export default AuthRoutes;
